import { Controller } from './Controller';

export abstract class CanvasObject<Type> {

  protected constructor(protected _x: number, protected _y: number, public meta: Type) {
  }

  public abstract update(
    controller: Controller,
    canvas: HTMLCanvasElement,
    c: CanvasRenderingContext2D
  ): void;

  public get x() {
    return this._x;
  }

  public get y() {
    return this._y;
  }

  protected set x(x: number) {
    this._x = x;
  }

  protected set y(y: number) {
    this._y = y;
  }

  protected getTransformedPoint(c: CanvasRenderingContext2D, x: number, y: number) {
    const inverseTransform = c.getTransform().invertSelf();
    const transformedX = inverseTransform.a * x + inverseTransform.c * y + inverseTransform.e;
    const transformedY = inverseTransform.b * x + inverseTransform.d * y + inverseTransform.f;

    return { x: transformedX, y: transformedY };
  }

}
